import {Component, Input, OnInit} from '@angular/core';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpBundleTemplate, TransactionListCta} from '@dcp/configurator';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Product} from '@spartacus/core';
import {Observable} from 'rxjs';
import {CtaInfoPageModalComponent} from '../cta-info-page-modal/cta-info-page-modal.component';

@UntilDestroy()
@Component({
  selector: 'dcp-cta-info-page-open-button',
  templateUrl: './cta-info-page-open-button.component.html',
  styleUrls: ['./cta-info-page-open-button.component.scss']
})
export class CtaInfoPageOpenButtonComponent implements OnInit {

  @Input() slmTransactionTypes: TransactionListCta[];
  @Input() bundleTemplate: DcpBundleTemplate;
  @Input() product: Product;

  private sortedSlmTransactionTypes$: Observable<TransactionListCta[]>;
  cta: TransactionListCta;

  constructor(
    public transactionTypeService: TransactionTypeService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit(): void {
    this.sortedSlmTransactionTypes$ = this.transactionTypeService.sortSlmTransactionTypesByPriority(this.slmTransactionTypes);
    this.sortedSlmTransactionTypes$.pipe(untilDestroyed(this)).subscribe(transactionTypes => {
      this.cta = transactionTypes.find(transactionType => !transactionType.disable);
      if (!this.cta) {
        this.cta = transactionTypes[0];
      }
    });
  }

  openInfoPageModal(): void {
    const modalRef = this.modalService.open(CtaInfoPageModalComponent, {windowClass: 'cta-info-modal'});
    modalRef.componentInstance.sortedSlmTransactionTypes$ = this.sortedSlmTransactionTypes$;
    modalRef.componentInstance.bundleTemplate = this.bundleTemplate;
    modalRef.componentInstance.product = this.product;
  }
}
